export default window.route;
